import $ from '../../plugins/query';
import tippy from 'tippy.js';
import {hideAll} from 'tippy.js';

class FormController {
    constructor() {
        FormController.doAll();
    }
	
    static get INPUT_SELECTOR() {
        return '.sos-form input[type=text],.sos-form input[type=number], .sos-form input[type=email], .sos-form input[type=tel], .sos-form input[type=password], .sos-form textarea';
    }
	
    static get SELECT_SELECTOR() {
        return '.sos-form select';
    }

    static get TOOLTIP_SELECTOR() {
        return '.sos-tool-tip';
    }
	
    static initTooltip(){
        //https://atomiks.github.io/tippyjs/v6/constructor/
        tippy(this.TOOLTIP_SELECTOR,{
            arrow: true,
            allowHTML: true,
            theme: 'light-border',
            // hideOnClick: false, //uncomment for debugging
            // trigger: 'click', //uncomment for debugging
            content(reference) {
                let titleDiv = '';
                const title = reference.getAttribute('data-title');
                if(title){
                    titleDiv = `<div class='title'>${title}</div>`
                }

                const content = reference.getAttribute('data-content');
                
                return `${titleDiv}<div class='content'>${content}</div>`;
            },
        });

        //this.hideTooltipOnScroll();
    }

    static hideTooltipOnScroll(){
        document.addEventListener('scroll', () => {
            hideAll({duration: 0});
        })
    }

    static doAll() {
        FormController.toggleInputState();
        FormController.toggleSelectClass();
        FormController.initTooltip();
    }
	
    static toggleInputState() {
        $(this.INPUT_SELECTOR).each((elem) => {
            if (elem.value !== '') {
                $(elem).addClass('has-value');
            }
            else {
                $(elem).removeClass('has-value');
            }
        });

        $(this.INPUT_SELECTOR).on('change', (event) => {
            const elem = event.currentTarget;
            if (elem.value !== '') {
                $(elem).addClass('has-value');
            }
            else {
                $(elem).removeClass('has-value');
            }
        });
    }

    static toggleSelectClass() {
        $(this.SELECT_SELECTOR).each((elem) => {
            if (elem.options[elem.options.selectedIndex].text.length > 0) {
                $(elem).addClass('has-value');
            }
        });
        $(this.SELECT_SELECTOR).on('change', (event) => {
            const elem = event.currentTarget;
            if (elem.options[elem.options.selectedIndex].text.length > 0) {
                $(elem).addClass('has-value');
            }
            else {
                $(elem).removeClass('has-value');
            }
        });
    }

    static init() {
        $(document).ready(() => {
            new FormController();
        });
    }
}

window.FormController = FormController;
export default FormController;
